import * as React from 'react';
import { useCallback, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import * as _ from 'lodash';
import MainHeader from '../../../headers/MainHeader/MainHeader';
import TestCasesPanel from '../TestCasesPanel/TestCasesPanel';
import * as actions from '../../../../redux/projects/actions.projects';
import * as microphoneActions from '../../../../redux/microphone/actions.microphone';
import * as scriptEditorActions from '../../../../redux/scriptEditor/actions.scriptEditor';
import ScriptArea from '../ScriptArea/ScriptArea';
import projectHelper from '../../../../services/ProjectHelper';
import CollapsiblePanel from '../../../components/CollapsiblePanel/CollapsiblePanel';
import CommandsPanel from '../CommandsPanel/CommandsPanel';
import VisualStatesPanel from '../VisualStatesPanel/VisualStatesPanel';
import DebuggingChat from '../DebuggingChat/DebuggingChat';
import AuthDataPanel from '../AuthDataPanel/AuthDataPanel';
import Overlay from '../../../components/Overlay/Overlay';
import { Resizer } from '../../../components/Resizer/Resizer';
import { Loader, LoaderSize, LoaderTheme } from '../../../components/Loader/Loader';
import isLocalStorageAvailable from '../../../../services/mini/isLocalStorageAvailable';
import { Environment } from '../../../../const/environment';
import messages from '../../../../const/messages';
import errorMessages from '../../../../const/errorMessages';
import errorCodes from '../../../../const/errorCodes';
import ScreenshotLogOverlay from '../../../components/ScreenshotLogOverlay/ScreenshotLogOverlay';
import HistoryKeeper from '../../../../services/HistoryKeeper';
import TestModePanel from '../TestMode/TestModePanel/TestModePanel';
import ProjectHeader from '../ProjectHeader/ProjectHeader';
import asyncDispatch from '../../../../services/mini/asyncDispatch';
import getUrlInfo from '../../../../services/mini/getUrlInfo';
import getPageTitle from '../../../../services/mini/getPageTitle';
import { InfoPanel, InfoPanelIcon } from '../../../components/InfoPanel/InfoPanel';
import { IGetPropjectParam, IReconnectProjectParam, IRememberProjectEnvironmentParam, IChangeEnvironmentParam } from '../../../../redux/projects/saga.projects';
import { IScript } from '../../../../models/IScript';
import { ProjectViewMode } from '../../../../const/projectViewMode';
import { IStore } from '../../../../redux/initialState';
import Dropzone from 'react-dropzone';
import { ImportFilesMode } from '../../../../const/ImportFilesMode';
import { confirmAlert } from '../../../../services/mini/alanConfirmAlert';
import ConfirmPopup from '../../../components/ConfirmPopup/ConfirmPopup';
import { broadcastReloadIframeToIframes } from '../../../../../../alan_btn/src/textChat/helpers/adjustIFrameSize';

type ProjectPageState = {
    environment: Environment,
    debugChatMinimized: boolean,
    isDebugPanelResized: boolean,
    files?: any[]
};

class ProjectPage extends React.Component<ProjectPageReduxProps, ProjectPageState> {
    constructor(props) {
        super(props);

        const environment = projectHelper.getEnvironment(this.props.projectId);
        let debugChatMinimized = false;

        if (isLocalStorageAvailable()) {
            debugChatMinimized = localStorage.getItem('debugging-chat__collapsed') === 'true';
        }

        this.state = {
            environment,
            debugChatMinimized,
            isDebugPanelResized: true
        };
    }

    debugChatResizer = React.createRef<Resizer>();
    debugChatRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
        HistoryKeeper.push();

        const { projectId } = this.props;
        const newEnvironment = projectHelper.getEnvironment(projectId);
        if (this.state.environment !== newEnvironment) {
            this.setState({ environment: newEnvironment });
        }
        this.getProjectDetail(projectId, newEnvironment);

        const urlInfo = getUrlInfo();
        document.title = getPageTitle(urlInfo.projectName);
    }

    componentDidUpdate(prevProps) {
        const {
            projectId,
            reconnectProject,
            projectMode,
        } = this.props;

        const {
            environment
        } = this.state;

        // if (projectMode !== prevProps.projectMode) {
        //     if (prevProps.projectMode === ProjectViewMode.Test) {
        //         reconnectProject({ projectId, environment });
        //     }
        // }

        if (projectId !== prevProps.projectId || environment !== projectHelper.getEnvironment(projectId)) {
            if (isLocalStorageAvailable() && projectId) {
                const environment = projectHelper.getEnvironment(projectId);
                this.setState({ environment });
                this.getProjectDetail(projectId, environment);
            } else {
                this.getProjectDetail(projectId, environment);
            }
        }


        if (
            this.state.files &&
            this.state.files.length &&
            this.props.importConflictScripts &&
            this.props.importConflictScripts.length &&
            this.props.importConflictScripts !== prevProps.importConflictScripts
        ) {
            this.showConfirmModal();
        }
    }

    onClose = () => {
        this.setState({ files: [] });
    }

    //todo: remove duplicated code
    showConfirmModal = () => {
        confirmAlert({
            customUI: ({ onClose }) => {
                const msg = <div>Your project already contains these scripts: {this.props.importConflictScripts.map((script, i) => <b key={script}>
                    {script}{i === this.props.importConflictScripts.length - 1 ? '. ' : ', '}
                </b>)} Would you like to replace existing scripts?
                </div>;
                return (
                    <ConfirmPopup
                        onClose={onClose}
                        okBtnLabel="Replace"
                        midBtnLabel="Don't replace"
                        okBtnCb={() => {
                            this.importFiles(ImportFilesMode.Replace);
                            onClose();
                        }}
                        midBtnCb={() => {
                            this.importFiles(ImportFilesMode.SkipConflicts);
                            onClose();
                        }}
                        title="Import Scripts"
                        message={msg}
                    />
                );
            },
            onClose: this.onClose,
        });
    };



    onBeforeWindowUnload(e) {
        e.returnValue = true;
        return true;
    }

    getScriptId(scriptName) {
        const { project } = this.props;
        let scriptId;

        if (!scriptName) {
            scriptName = this.props.scriptName;
        }

        for (var i = 0; i < project.scripts.length; i++) {
            if (project.scripts[i].name === scriptName) {
                scriptId = project.scripts[i].scriptId;
                break;
            }
        }
        return scriptId;

    }

    getProjectDetail(projectId, environment) {
        if (projectId && !_.isUndefined(environment)) {
            this.props.getProject({ projectId, environment });
        }
    }

    changeEnvironment = ({ project, environment }) => {
        this.setState({ environment });
        this.props.changeEnvironment({ project, environment });
        this.props.rememberProjectEnvironment({
            projectId: project.projectId,
            environment
        });
    }

    expandDebugChatPanel = () => {
        this.debugChatResizer.current?.toggle(null);
    }

    collapseDebugChatPanel = () => {
        this.debugChatRef.current?.setAttribute('style', '');
        this.debugChatResizer.current?.collapse(null);
    }

    onResizerStateChange = (state) => {
        if (state.isOpened !== this.state.debugChatMinimized) {
            this.setState({
                debugChatMinimized: !state.isOpened,
            });
        }
    };

    onResizeStart = () => {
        this.setState({ isDebugPanelResized: true });
    }

    onResizeEnd = ({ width }) => {
        this.setState({ isDebugPanelResized: false });
        if (width < 60) {
            this.collapseDebugChatPanel();
            this.setState({ debugChatMinimized: true });
            if (isLocalStorageAvailable()) {
                localStorage.setItem('debugging-chat__collapsed', 'true');
            }
        } else {
            this.setState({ debugChatMinimized: false });
            this.debugChatResizer.current.setOpenedState(true);
            if (isLocalStorageAvailable()) {
                localStorage.setItem('debugging-chat__collapsed', 'false');
            }
        }


        broadcastReloadIframeToIframes();

        return true;
    }

    importFiles = (importMode = ImportFilesMode.Default) => {
        const { environment, files } = this.state;
        const { importFiles, project } = this.props;

        importFiles({
            project,
            files,
            importMode,
            environment
        });
    }

    onDrop = (files) => {
        const {
            project,
            projectMode,
        } = this.props;

        const { environment } = this.state;

        const isLastTag = projectHelper.isLastTag(project, project[`${environment}TagId`])

        if (!isLastTag) return;
        if (environment !== Environment.Staging) return;
        if (projectMode !== ProjectViewMode.Edit) return;

        this.setState({
            files,
        }, () => {
            this.importFiles();
        });
    }

    render() {
        const {
            projectName,
            project,
            scriptName,
            hasProjectsData,
            isScriptSaving,
            projectMode,
            projectDecriptionError,
            tagId,
            script,
            githubDeployId,
            isModelActual,
            syntaxErrors,
            hasRuntimeErrors,
            hasUnsavedChanges,
            transformMode,
        } = this.props;
        const {
            environment
        } = this.state;

        const showLastVersionWarning = environment === Environment.Production && projectHelper.isLastTag(project, project.prodTagId);

        const hasScripts = (project.hasScriptsData && project.scripts && project.scripts.length > 0);
        const isCiCd = githubDeployId !== '';
        const hasSyntaxErrors = syntaxErrors?.length > 0;

        const isDndImportAllowed = projectMode === ProjectViewMode.Edit &&
            environment === Environment.Staging &&
            projectHelper.isLastTag(project, project[`${environment}TagId`]);

        return (
            <div className={`project-page`}>
                <MainHeader
                    className="project-page_header-content-wrapper"
                    environment={environment}>
                    <InfoPanel
                        className="project-page_syntax-err-banner"
                        title={`Your project has syntax error(s)`}
                        visible={hasScripts && hasSyntaxErrors && !hasUnsavedChanges && script.type !== 'transform'}
                        icon={InfoPanelIcon.Error}
                        error={true}
                        onClick={() => {
                            this.props.openErrors({ shouldScrollToFirstError: true });
                        }}
                    />
                    <ProjectHeader
                        projectName={projectName}
                        scriptName={scriptName}
                        projectMode={projectMode}
                        changeEnvironment={this.changeEnvironment}
                        environment={environment} />
                </MainHeader>
                <InfoPanel title={messages.lastVersionIsOnProd} visible={showLastVersionWarning} />
                <InfoPanel title={errorMessages[errorCodes.decryptionError]} visible={projectDecriptionError} error={true} icon={InfoPanelIcon.Error} />
                <InfoPanel title="CI/CD pipeline is enabled for a GitHub repository. Viewing read-only version" visible={isCiCd} icon={InfoPanelIcon.Locked} />
                <Dropzone
                    onDrop={this.onDrop}
                    noClick={true}
                    noKeyboard={true}>
                    {({ getRootProps, getInputProps, isDragActive }) => (
                        <div className={`project-page_container ${!hasProjectsData && 'hidden'} ${(isDragActive && isDndImportAllowed) && 'active'}`} {...getRootProps()}>
                            {projectMode === ProjectViewMode.Edit ?
                                <div className="project-page_container_edit-mode">

                                    {(project.addingScriptsIsInprocess || project.isImportingScriptsInProgress) &&
                                        <Overlay>
                                            <Loader
                                                theme={LoaderTheme.Light}
                                                size={LoaderSize.Big} />
                                        </Overlay>}

                                    <div className="project-page_container_list-and-script-and-chat">


                                        <div className="project-page_container_list-and-script">
                                            <CommandsPanel place="chat" />
                                            <AuthDataPanel
                                                environment={environment}
                                                project={project} />
                                            <VisualStatesPanel place="chat" />

                                            {project.projectId && <ScriptArea
                                                projectMode={projectMode}
                                                project={project}
                                                tagId={tagId}
                                                hasScripts={hasScripts}
                                                script={script}
                                                isScriptSaving={isScriptSaving}
                                                projectName={projectName}
                                                scriptName={scriptName}
                                                environment={environment}
                                                transformMode={transformMode}
                                                selectedStageTagId={project.stageTagId}
                                                selectedProdTagId={project.prodTagId}
                                            />}
                                        </div>
                                        {(hasScripts && !transformMode) &&
                                            <Resizer
                                                lsKey={'DebugChatResizerRoot'}
                                                ref={this.debugChatResizer}
                                                y={100}
                                                x={25}
                                                min={0}
                                                max={50}
                                                isOpened={!this.state.debugChatMinimized}
                                                onResizeEnd={this.onResizeEnd}
                                                onStateChange={this.onResizerStateChange}
                                                onResizeStart={this.onResizeStart}
                                                styleName={'debug-chat__resizer'}
                                                divider="left">
                                                <div ref={this.debugChatRef} className="debug-chat__collapsible-wrapper alanStudio-debug-chat">
                                                    <CollapsiblePanel
                                                        title="Debugging Chat"
                                                        id="debugging-chat__collapsed"
                                                        panelClassName="debugging-chat-panel"
                                                        shortPanelClassName={`debugging-chat-short-panel ${environment}`}
                                                        direction="right"
                                                        collapsed={this.state.debugChatMinimized}
                                                        onPanelCollapsed={() => {
                                                            this.setState({ debugChatMinimized: true });
                                                            this.collapseDebugChatPanel();
                                                        }}
                                                        onPanelExpanded={() => {
                                                            this.setState({ debugChatMinimized: false });
                                                            this.expandDebugChatPanel();
                                                        }}
                                                    >
                                                        <DebuggingChat
                                                            environment={environment}
                                                            showVisualStateBtn={true}
                                                            showAuthDataBtn={true}
                                                            showQrCodeBtn={true}
                                                        />
                                                    </CollapsiblePanel>
                                                </div>
                                            </Resizer>}
                                    </div>
                                </div> :
                                <div className="project-page_container_test-mode">
                                    {project.isImportingOfTestCasesInProgress &&
                                        <Overlay>
                                            <Loader
                                                theme={LoaderTheme.Light}
                                                size={LoaderSize.Big} />
                                        </Overlay>}
                                    {!isModelActual &&
                                        <Overlay className="project-page_container_test-mode-updating-nodel">
                                            <div className="test-mode-panel__model-is-updating model-loader">
                                                Model is updating...
                                            </div>
                                        </Overlay>}
                                    <CollapsiblePanel
                                        title="Test Cases"
                                        direction="left"
                                        id="test-cases"
                                        disabled={!(project && project.projectId)}>
                                        <TestCasesPanel
                                            environment={environment}
                                            selectedStageTagId={project.stageTagId}
                                            project={project}
                                            conversationName={this.props.conversationName}
                                        />
                                    </CollapsiblePanel>
                                    {project.hasScriptsData &&
                                        <TestModePanel
                                            project={project}
                                            environment={environment}
                                            conversation={this.props.conversation}
                                            conversationName={this.props.conversationName} />
                                    }
                                </div>
                            }
                        </div>
                    )}
                </Dropzone>
                <ScreenshotLogOverlay />
            </div>
        );
    }
}

function mapStateToProps({ projectsInfo, codeMetaData, scriptEditor, gitHubIntegration }: IStore, ownProps) {
    const projectName = ownProps.params.projectName;
    const scriptName = ownProps.params.scriptName;
    const conversationName = ownProps.params.conversationName;
    const projectMode = ownProps.route.editMode ? ProjectViewMode.Edit : ProjectViewMode.Test;
    let projectId = '';
    const allProjects = projectsInfo.projects;
    const project = projectsInfo.currentProject;

    for (let i = 0; i < allProjects.length; i++) {
        if (allProjects[i].name === projectName) {
            projectId = allProjects[i].projectId;
            break;
        }

    }

    let script = {} as IScript;
    if (project.scripts) {
        for (let i = 0; i < project.scripts.length; i++) {
            if (project.scripts[i].name === scriptName) {
                script = project.scripts[i];
                break;
            }
        }
    }

    let conversation = {};
    if (project.conversations) {
        for (let i = 0; i < project.conversations.length; i++) {
            if (project.conversations[i].name === conversationName) {
                conversation = project.conversations[i];
                break;
            }
        }
    }


    return {
        projectName,
        projectId,
        scriptName,
        conversationName,
        script,
        conversation,
        projectMode,
        transformMode: script?.type === 'transform',
        isScriptSaving: projectsInfo.currentProject.isScriptSaving,
        project: projectsInfo.currentProject,
        projectDecriptionError: projectsInfo.currentProject.projectDecriptionError,
        hasProjectsData: projectsInfo.hasProjectsData,
        tagId: project.stageTagId,
        githubDeployId: gitHubIntegration.githubDeployId,
        isModelActual: projectsInfo.currentProject.isModelActual,
        syntaxErrors: codeMetaData.syntaxErrors,
        hasUnsavedChanges: codeMetaData.hasUnsavedChanges,
        hasRuntimeErrors: projectsInfo.currentProject.hasRuntimeErrors,
        importConflictScripts: projectsInfo.currentProject.importConflictScripts,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getProject: (param: IGetPropjectParam) => asyncDispatch(actions.getProject, dispatch, param),
        reconnectProject: (param: IReconnectProjectParam) => dispatch(actions.reconnectProject(param)),
        clearChatMessages: () => dispatch(actions.clearChatMessages()),
        changeEnvironment: (param: IChangeEnvironmentParam) => dispatch(actions.changeEnvironment(param)),
        disconnectFromProject: () => dispatch(actions.disconnectFromProject()),
        stopMicrophone: () => dispatch(microphoneActions.stopMicrophone()),
        openErrors: (param: scriptEditorActions.IOpenErrorsParams) => dispatch(scriptEditorActions.openErrors(param)),
        rememberProjectEnvironment: (param: IRememberProjectEnvironmentParam) => dispatch(actions.rememberProjectEnvironment(param)),
        importFiles: (param) => asyncDispatch(actions.importFiles, dispatch, param),
    };
}


const connector = connect(mapStateToProps, mapDispatchToProps);

type ProjectPageReduxProps = ConnectedProps<typeof connector>;

export default connector(ProjectPage);
